import { Container } from "inversify";
import "reflect-metadata";
import { IRoute } from "../routing/routeInterface";
import { TYPES } from "./types";
import IAppConfig, { DefaultAppConfig } from "../config";
import { DossierRoute, InviteToDossierRoute, LoginRoute, NewDossierRoute } from "../routing/routes";
import { DossierApiClient, IDossierApiClient } from "../clients/dossierApiClient";
import { IUserApiClient, UserApiClient } from "../clients/userApiClient";
const iocContainer = new Container();

const RegisterRoutes = () => {
    // iocContainer.bind<IRoute>(TYPES.IRoute).to(DashboardRoute);
    // iocContainer.bind<IRoute>(TYPES.IRoute).to(TeamsRoute);
    // iocContainer.bind<IRoute>(TYPES.IRoute).to(EmployeesRoute);
    // iocContainer.bind<IRoute>(TYPES.IRoute).to(ContentRoute);
    // iocContainer.bind<IRoute>(TYPES.IRoute).to(UsersRoute);
    // iocContainer.bind<IRoute>(TYPES.IRoute).to(OrganisationsRoute);
    // iocContainer.bind<IRoute>(TYPES.IRoute).to(CreateEvaluationRoute);
    // iocContainer.bind<IRoute>(TYPES.IRoute).to(EmployeeRoute);
    // iocContainer.bind<IRoute>(TYPES.IRoute).to(LoginRoute);
    // iocContainer.bind<IRoute>(TYPES.IRoute).to(ResetPasswordRoute);
    // iocContainer.bind<IRoute>(TYPES.IRoute).to(PasswordForgotRoute);
    // iocContainer.bind<IRoute>(TYPES.IRoute).to(UpdateEvaluationRoute);
    // iocContainer.bind<IRoute>(TYPES.IRoute).to(CreateTaskRoute);
    // iocContainer.bind<IRoute>(TYPES.IRoute).to(UpdateTaskRoute);
    
    iocContainer.bind<IAppConfig>(TYPES.IAppConfig).to(DefaultAppConfig);
    iocContainer.bind<IRoute>(TYPES.IRoute).to(DossierRoute);
    iocContainer.bind<IRoute>(TYPES.IRoute).to(LoginRoute);
    iocContainer.bind<IRoute>(TYPES.IRoute).to(NewDossierRoute);
    iocContainer.bind<IDossierApiClient>(TYPES.IDossierClient).to(DossierApiClient);
    iocContainer.bind<IUserApiClient>(TYPES.IUserClient).to(UserApiClient)
    iocContainer.bind<IRoute>(TYPES.IRoute).to(InviteToDossierRoute);
}
RegisterRoutes();
export { iocContainer };



